module.exports = __webpack_public_path__ + "img/h_8.638edf01.png";